export const primaryColor = "#550475",
  lightPrimaryColor = "#9B59B6",
  headerFamily = "'Comfortaa', cursive",
  bodyFamily = "'Arima Madurai', cursive",
  white = "rgb(255, 255, 255)";
